module.exports = __webpack_public_path__ + "img/logo.c2c95815.png";